export default __webpack_public_path__ + "static/media/logomark-16.5c7f23be.svg";